<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24 18.77H0C0.11 12.716 5.449 7.821 12 7.821C18.552 7.821 23.89 12.716 24 18.77ZM12 0C13.654 0 15 1.403 15 3.128C15 4.854 13.654 6.257 12 6.257C10.346 6.257 9 4.854 9 3.129C9 1.404 10.346 0 12 0ZM0 20.334H24V23.462H0V20.334Z" fill="currentColor"/>
</svg>
